import { render, staticRenderFns } from "./DuplicateProjects.vue?vue&type=template&id=b64e7278&scoped=true"
import script from "./DuplicateProjects.vue?vue&type=script&lang=js"
export * from "./DuplicateProjects.vue?vue&type=script&lang=js"
import style0 from "./DuplicateProjects.vue?vue&type=style&index=0&id=b64e7278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64e7278",
  null
  
)

export default component.exports